import data from "../../../../../src/AnchoredOverlay/AnchoredOverlay.docs.json";
import * as React from 'react';
export default {
  data,
  React
};